import { useState } from 'react';
import axios from 'axios';

import getConfig from '../../../util/config';
import getLogger from '../../../util/logger';

const log = getLogger('Logout Hook');
/**
 * Logout hook
 * */

const useLogout = () => {
  const [loading, setLoading] = useState(false);
  const config = getConfig();

  const logout = async ({ redirectUrl } = {}) => {
    if (loading) {
      return;
    }

    try {
      await axios.post('/auth/request-logout/');

      if (window.location) {
        window.location = redirectUrl || config.app.baseUrl;
      }
    } catch (error) {
      log.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    logout,
  };
};

export default useLogout;
